import { motion } from "framer-motion";

export default function Logo({ size = 34, withText = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" data-testid="brand-logo">
        <rect x="3" y="3" width="9" height="9" rx="1.5" fill="#0047FF" opacity="0.55" />
        <rect x="3" y="28" width="9" height="9" rx="1.5" fill="#0047FF" opacity="0.55" />
        <rect x="14.5" y="15.5" width="9" height="9" rx="1.5" fill="#00F0FF" opacity="0.8" />
        <rect x="26" y="7" width="11" height="26" rx="3" stroke="#00F0FF" strokeWidth="1.6" fill="#040710" />
        <path d="M31.5 20l1.2 2.5 2.6.3-1.9 1.8.5 2.6-2.4-1.3-2.4 1.3.5-2.6-1.9-1.8 2.6-.3z" fill="#00F0FF" />
      </svg>
      {withText && (
        <span className="font-display font-700 leading-none tracking-tight text-[13px] sm:text-[15px]">
          APP CHALLENGE<br /><span className="text-cyan">ACADEMY</span>
        </span>
      )}
    </span>
  );
}

export function ConvergeMark({ className = "" }) {
  return (
    <motion.svg viewBox="0 0 200 200" className={className}
      initial="hidden" whileInView="show" viewport={{ once: true }}>
      {[[20,20],[20,150],[150,20]].map(([x,y],i)=>(
        <motion.rect key={i} x={x} y={y} width="24" height="24" rx="4" fill="#0047FF"
          variants={{ hidden:{opacity:0}, show:{opacity:[0.3,0.9,0.5], transition:{duration:2, repeat:Infinity, delay:i*0.3}}}} />
      ))}
      <motion.line x1="32" y1="32" x2="120" y2="100" stroke="#00F0FF" strokeWidth="1" opacity="0.4"/>
      <motion.line x1="32" y1="162" x2="120" y2="100" stroke="#00F0FF" strokeWidth="1" opacity="0.4"/>
      <rect x="118" y="60" width="60" height="90" rx="10" stroke="#00F0FF" strokeWidth="2" fill="#090E1D"/>
    </motion.svg>
  );
}
